import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import Footer from "./footer";
import "../index.css";

const BASE_URL = process.env.REACT_APP_DATA_FEEDER;


const SourceDailyWeeklyData = () => {
  const [todaysData, setTodaysData] = useState([]);
  const [lastSevenEntries, setLastSevenEntries] = useState([]);
  const [latestPresentData, setLatestPresentData] = useState([]);

  const [pageToday, setPageToday] = useState(1);
  const [pageLastSeven, setPageLastSeven] = useState(1);
  const [pageLatest, setPageLatest] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const token = sessionStorage.getItem("jwtToken");
  const xApiKey = sessionStorage.getItem("xApiKey");

  const fallbackData = [
    //   {
    //       "tableName": "Valuation table",
    //       "tableReportList": {
    //           "SymbolValuationData": [
    //               {
    //                   "tableName": "SymbolValuationData",
    //                   "rowsSourced": 1473,
    //                   "sourcedDate": null,
    //                   "logName": "Mar2026",
    //                   "status": "SUCCESS"
    //               }
    //           ]
    //       }
    //   },
    //   {
    //       "tableName": "Quarterly Tables",
    //       "tableReportList": {
    //           "SymbolFinancialDataQuarterly": [
    //               {
    //                   "tableName": "SymbolFinancialDataQuarterly",
    //                   "rowsSourced": 0,
    //                   "sourcedDate": "2026-03-31",
    //                   "logName": "Mar2026",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "SymbolFinancialDataQuarterly",
    //                   "rowsSourced": 1455,
    //                   "sourcedDate": "2025-12-31",
    //                   "logName": "Dec2025",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "SymbolFinancialDataQuarterly",
    //                   "rowsSourced": 1473,
    //                   "sourcedDate": "2025-09-30",
    //                   "logName": "Sep2025",
    //                   "status": "SUCCESS"
    //               }
    //           ],
    //           "stockkeymetricsdataquarterly": [
    //               {
    //                   "tableName": "stockkeymetricsdataquarterly",
    //                   "rowsSourced": 0,
    //                   "sourcedDate": "2026-03-31",
    //                   "logName": "Mar2026",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "stockkeymetricsdataquarterly",
    //                   "rowsSourced": 1480,
    //                   "sourcedDate": "2025-12-31",
    //                   "logName": "Dec2025",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "stockkeymetricsdataquarterly",
    //                   "rowsSourced": 1491,
    //                   "sourcedDate": "2025-09-30",
    //                   "logName": "Sep2025",
    //                   "status": "SUCCESS"
    //               }
    //           ]
    // }
    //   }
  ];

  const fallbackTodayData = [
    //   {
    //       "tableName": "Valuation table",
    //       "tableReportList": {
    //           "SymbolValuationData": [
    //               {
    //                   "tableName": "SymbolValuationData",
    //                   "rowsSourced": 1473,
    //                   "sourcedDate": null,
    //                   "logName": "Mar2026",
    //                   "status": "SUCCESS"
    //               }
    //           ]
    //       }
    //   },
    //   {
    //       "tableName": "Quarterly Tables",
    //       "tableReportList": {
    //           "SymbolFinancialDataQuarterly": [
    //               {
    //                   "tableName": "SymbolFinancialDataQuarterly",
    //                   "rowsSourced": 0,
    //                   "sourcedDate": "2026-03-31",
    //                   "logName": "Mar2026",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "SymbolFinancialDataQuarterly",
    //                   "rowsSourced": 1455,
    //                   "sourcedDate": "2025-12-31",
    //                   "logName": "Dec2025",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "SymbolFinancialDataQuarterly",
    //                   "rowsSourced": 1473,
    //                   "sourcedDate": "2025-09-30",
    //                   "logName": "Sep2025",
    //                   "status": "SUCCESS"
    //               }
    //           ],
    //           "stockkeymetricsdataquarterly": [
    //               {
    //                   "tableName": "stockkeymetricsdataquarterly",
    //                   "rowsSourced": 0,
    //                   "sourcedDate": "2026-03-31",
    //                   "logName": "Mar2026",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "stockkeymetricsdataquarterly",
    //                   "rowsSourced": 1480,
    //                   "sourcedDate": "2025-12-31",
    //                   "logName": "Dec2025",
    //                   "status": "SUCCESS"
    //               },
    //               {
    //                   "tableName": "stockkeymetricsdataquarterly",
    //                   "rowsSourced": 1491,
    //                   "sourcedDate": "2025-09-30",
    //                   "logName": "Sep2025",
    //                   "status": "SUCCESS"
    //               }
    //           ]
    // }
    //   }
  ];

  useEffect(() => {
    fetch(`${BASE_URL}/data/checkSchedulerLogAndDataSourcedToday-UI-report`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-API-KEY": xApiKey,
      },
    })
      .then((res) => res.json())
      .then((data) => setTodaysData(data))
      .catch(() => setTodaysData(fallbackTodayData));

    fetch(`${BASE_URL}/data/lastSevenSourcingReport`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-API-KEY": xApiKey,
      },
    })
    .then(res => res.json())
    .then(data => setLastSevenEntries(flattenSchedulerData(data)))
    .catch(() => setLastSevenEntries(flattenSchedulerData(fallbackData)));


    fetch(`${BASE_URL}/data/latestPresentDataReport`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-API-KEY": xApiKey,
      },
    })
      .then((res) => res.json())
      .then((data) => setLatestPresentData(flattenGroupedData(data)))
      .catch(() => setLatestPresentData(flattenGroupedData(fallbackData)));
  }, []);

  const renderPagination = (data, currentPage, setPage) => {
    const totalPages = Math.ceil(data.length / rowsPerPage);

    if (totalPages <= 1) return null;

    return (
      <nav className="mt-3">
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => setPage(currentPage - 1)}
            >
              Previous
            </button>
          </li>

          {[...Array(totalPages)].map((_, index) => (
            <li
              key={index}
              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
            >
              <button className="page-link" onClick={() => setPage(index + 1)}>
                {index + 1}
              </button>
            </li>
          ))}

          <li
            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => setPage(currentPage + 1)}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  const flattenSchedulerData = (apiData) => {
    const result = [];

    (apiData || []).forEach(group => {

      result.push({
        isMainGroup: true,
        groupName: group.tableName
      });

      const tables = group.tableReportList || {};

      Object.keys(tables).forEach(table => {

        result.push({
          isTable: true,
          tableName: table
        });

        tables[table].forEach(row => {

          result.push({
            rowsSourced: row.rowsSourced,
            sourcedDate: row.sourcedDate,
            logName: row.logName,
            status: row.status,
            startTime: row.startTime,
            endTime: row.endTime,
            timeTaken: row.timeTaken
          });

        });

      });

    });

    return result;
  };

const flattenGroupedData = (apiData) => {
    const result = [];  

    (apiData || []).forEach((group) => {
      // Main group name
      result.push({
        isMainGroup: true,
        groupName: group.tableName,
      });

      const tables = group.tableReportList || {};

      Object.keys(tables).forEach((table) => {
        // Table name row
        result.push({
          isTable: true,
          tableName: table,
        });

        tables[table].forEach((row) => {
          result.push({
            rowsSourced: row.rowsSourced,
            sourcedDate: row.sourcedDate,
            logName: row.logName,
            status: row.status,
          });
        });
      });
    });

    return result;
  };

  const renderTable = (title, data, currentPage, setPage) => {

    const showSchedulerColumns = title === "Today's Data" || title === "Last 7 Entries";
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginatedData = data.slice(startIndex, startIndex + rowsPerPage);

    return (
      <div className="container-fluid mb-5">
        <h3 className="fw-bold text-center mb-3">{title}</h3>

        <div className="table-responsive" style={{ marginBottom: "200px" }}>
          <table className="table table-bordered  align-middle">
            <thead className="table-light">
              <tr>
                <th>ID</th>
                <th>Rows Sourced</th>
                <th>Sourced Date</th>
                <th>Log Name</th>
                <th>Status</th>    
                {showSchedulerColumns && (
                  <>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Time Taken</th>
                  </>
                )}
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((item, index) => {
                if (item.isMainGroup) {
                  return (
                    <tr key={index} className="table-secondary fw-bold" style={{fontSize:"18px"}}>
                        <td colSpan={showSchedulerColumns ? 8 : 5}>
                          {item.groupName}
                        </td>
                    </tr>
                  );
                }

                if (item.isTable) {
                  return (
                    <tr key={index} className="table-light">
                        <td colSpan={showSchedulerColumns ? 8 : 5}>
                          {item.tableName}
                        </td>
                    </tr>
                  );
                }

                return (
                  <tr key={index}>
                    <td>{startIndex + index + 1}</td>
                    <td>{item.rowsSourced}</td>
                    <td>{item.sourcedDate}</td>
                    <td>{item.logName}</td>
                    <td>{item.status}</td>

                    {showSchedulerColumns && (
                      <>
                        <td>{item.startTime}</td>
                        <td>{item.endTime}</td>
                        <td>{item.timeTaken}</td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <nav className="d-flex justify-content-center mt-3">
            {renderPagination(data, currentPage, setPage)}
            <div
              className="justify-content-between align-items-center mt-3"
              style={{ paddingLeft: "50px" }}
            >
              <span className="me-2">Show</span>
              <select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setPage(1);
                }}
                className="form-select d-inline-block"
                style={{ width: "80px" }}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <span className="ms-2">entries</span>
            </div>
          </nav>
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />

      <div className="main-content" style={{ paddingTop: "50px" }}>
        {renderTable("Today's Data", todaysData, pageToday, setPageToday)}

        {renderTable(
          "Last 7 Entries",
          lastSevenEntries,
          pageLastSeven,
          setPageLastSeven,
        )}

        {renderTable(
          "Latest Present Data",
          latestPresentData,
          pageLatest,
          setPageLatest,
        )}
      </div>

      <Footer />
    </>
  );
};

export default SourceDailyWeeklyData;
